import React, { useEffect, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { SkipLink } from '@/components/custom/SkipLink';

interface AuthRouteLayoutProps {
  component: ReactNode;
}

export const AuthRouteLayout: React.FC<AuthRouteLayoutProps> = ({ component }) => {
  const navigate = useNavigate()
  const [cookies,] = useCookies(['tcsAccessToken', 'tcsRefreshToken'])

  useEffect(() => { 
    if (cookies.tcsRefreshToken) { 
      navigate('/router')
    }
  }, [cookies, navigate])

  return (
    <>
      <SkipLink />
      <main id="main-content" className="w-full" tabIndex={-1}>
        {component}
      </main>
    </>
  );
};

